/**
 * Homepage "where FixControl fits" — three short contrasts with the products
 * a visitor will mentally file FixControl under after reading the hero
 * (support AI, a coding assistant, an agent that acts on its own). Product-
 * focused, no competitor names; the architecture comparisons with workflow
 * tools, enterprise search and ServiceNow stay in the lower Boundaries
 * section and on /compare.
 */

import { Code2, MessageSquare, ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/reveal";
import { useT } from "@/i18n";

const ITEMS = [
  { key: "support", Icon: MessageSquare },
  { key: "coding", Icon: Code2 },
  { key: "unchecked", Icon: ShieldCheck },
] as const;

export function FitSection() {
  const t = useT();
  return (
    <section id="fit" className="border-b border-line-subtle bg-bg-raised/40">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-6 md:py-20">
        <Reveal>
          <h2 className="text-balance text-2xl font-semibold tracking-tight text-fg-bright md:text-3xl">
            {t("landing.different.title")}
          </h2>
        </Reveal>
        <div className="mt-8 grid gap-4 md:grid-cols-3">
          {ITEMS.map(({ key, Icon }, i) => (
            <Reveal key={key} delay={i * 60}>
              <div className="card h-full p-5">
                <div className="flex items-center gap-2.5">
                  <Icon size={16} aria-hidden className="shrink-0 text-brand-300" />
                  <h3 className="text-[15px] font-semibold text-fg-bright">
                    {t(`landing.different.items.${key}.title`)}
                  </h3>
                </div>
                <p className="mt-2.5 text-[13.5px] leading-relaxed text-fg-dim">
                  {t(`landing.different.items.${key}.body`)}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
